import { reactify } from '@zeiss/zui-react';
export const ZuiIconMedCoObserver1D = reactify('zui-icon-med-co-observer-1-d');
